module.exports = __webpack_public_path__ + "img/video.6d5c52f3.gif";